module.exports = __webpack_public_path__ + "img/logo.10cf7192.png";